import React, {useState} from 'react';

import SideModal from '../components/side-modal';

export default function withSideModal(WrappedComponent) {
  return props => {
    const [data, setData] = useState({isOpen: false, renderContent: () => null});

    return (
      <>
        <WrappedComponent
          toggleSideModal={setData}
          {...props}
        />
        {data.isOpen && <SideModal renderContent={data.renderContent} toggleSideModal={setData} />}
      </>
    );
  };
}
